import { faBan } from "@fortawesome/pro-regular-svg-icons/faBan";
import * as React from "react";
import { MprcIconFa, MprcIconFaProps } from "../MprcIconFa";

export const IconBlocked: React.FC<Omit<MprcIconFaProps, "icon">> = (props) => {
    return <MprcIconFa {...props} icon={faBan} />;
};
